import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateDiscountOfferEntity } from '../../domain/entities/CreateDiscountOfferEntity'
import { DiscountType } from '@/backend/market/models/DiscountType'

export class CreateDiscountOfferModel extends CreateDiscountOfferEntity {
  type = DiscountType.PERCENT
  value = 0  
  serviceRatio = 0
  branchRatio = 0
  startDate!: string
  endDate!: string  
  userIds?: Array<string> | null
  categoryIds?: Array<number> | null
  specifiedItemIds?: Array<number> | null
  groupIds?: Array<number> | null
  branchId?: number

  constructor(dataDto: CreateDiscountOfferEntity) {
    super()
    mapEntityProperties<CreateDiscountOfferModel>(this, dataDto, {
      exclude: ['start', 'end', 'users', 'categories', 'items', 'branch', 'groups'],
      map: {
        startDate: dataDto.start ? (dataDto.start) : '',
        endDate: dataDto.end ? (dataDto.end) : '',
        userIds: dataDto?.users?.map((user) => user.id),
        categoryIds: dataDto?.categories?.map((category) => category.id) || [],
        specifiedItemIds: dataDto?.items?.map((item) => item.id) || [],
        groupIds: dataDto?.groups?.map((group) => group.id),
        branchId: dataDto?.branch?.id
      }
    })
  }
}
